import React from "react";
import "./FinanceDashboard.scss";

const FinanceDashboard = () => {
  return (
    <div className="finance-dashboard">
      <div className="finance-photo-card">
          <img className="finance-img2" src="../assets/img/finance/faq-two-image.jpg" alt="" />
      </div>

      <div className="finance-faq-card">
        <div className="finance-faq-title">FAQ'S</div>
        <h2 className="finance-faq-heading">Frequently Ask Question</h2>
        <p className="finance-faq-para">
          While Google Ads is a highly effective advertising platform, it's
          essential to explore other channels to maximize your ad reach and
          impact.
        </p>
        <div className="finance-faq-item">
          <div className="finance-faq-item-inner">
            <div className="finance-faq-item-num">03</div>
            <span className="finance-faq-item-para">Transforming Lives</span>
          </div>
          <span class="material-symbols-outlined">arrow_forward</span>
        </div>
        <div className="finance-faq-item">
          <div className="finance-faq-item-inner">
            <div className="finance-faq-item-num">01</div>
            <span className="finance-faq-item-para">One Program At a Time</span>
          </div>
          <span class="material-symbols-outlined">arrow_forward</span>
        </div>
        <div className="finance-faq-item">
          <div className="finance-faq-item-inner">
            <div className="finance-faq-item-num">02</div>
            <span className="finance-faq-item-para">Through Proven Programs</span>
          </div>
          <span class="material-symbols-outlined">arrow_forward</span>
        </div>
      </div>
    </div>
  );
};

export default FinanceDashboard;
